import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type {
  InitialStateType,
  SetLoginStoriesPayloadType,
  SetQueryPayloadActionType,
  SetLoginStoryPayloadType,
  SetMediaImageRulesPayloadActionType,
  SetMediaFileRulesPayloadActionType,
  SetBackgroundImagesPayloadType,
  SetBackgroundImagePayloadActionType,
  BackgroundImagesType,
} from 'features/CategoryAndPosisi/@types/onboardingMedia'
import { Options } from 'react-lottie'

export const LOTTIE_OPTION_DEFAULT: Options = {
  loop: true,
  autoplay: true,
  animationData: null,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
}

export const BACKGROUND_IMAGE_LOTTIE_DEFAULT: BackgroundImagesType = {
  active: false,
  background_image_file: null,
  background_image_preview: '',
  background_image_url: '',
  formTitle: '',
  id: 1,
  illustration_image_file: null,
  illustration_image_preview: '',
  illustration_image_url: '',
  position: 0,
  subtitle: '',
  title: '',
  type: 'ANIMATED_IMAGE_V2',
  uniqueID: window.crypto.randomUUID(),
  lottieOptions: LOTTIE_OPTION_DEFAULT,
  illustration_image_url_large: '',
  illustration_image_url_medium: '',
  illustration_image_url_small: '',
}

export const SLICE_NAME = 'onboardingMedia'
export const initialState: InitialStateType = {
  isLoading: [],
  query: {
    direction: '',
    page_index: 0,
    page_size: 16,
    sort: '',
    type: '',
  },
  loginStories: [],
  backgroundImages: [],
  backgroundImagesV2: [],
  mediaRules: {
    images: {
      loginStory: {
        extensions: [],
        height: { max: 0, min: 0 },
        maxFileSize: 0,
        typeId: 'product-placement-new-login-stories',
        width: { max: 0, min: 0 },
      },
      backgroundImage: {
        extensions: [],
        height: { max: 0, min: 0 },
        maxFileSize: 0,
        typeId: 'new-login-stories-image-v2',
        width: { max: 0, min: 0 },
      },
    },
    files: {
      background: { extensions: [], maxFileSize: 0, typeId: 'new-login-stories-image-lottie' },
    },
  },
}

const onboardingMedia = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    reset: () => initialState,
    setQuery: (state, action: PayloadAction<SetQueryPayloadActionType>) => {
      state.query = {
        ...state.query,
        ...action.payload,
      }
    },
    setIsloading: (state, action: PayloadAction<boolean>) => {
      if (action.payload) {
        state.isLoading.push(true)
      } else {
        state.isLoading.pop()
      }
    },
    setLoginStories: (state, action: PayloadAction<SetLoginStoriesPayloadType>) => {
      state.loginStories = action.payload
    },
    setMediaImageRule: (state, action: PayloadAction<SetMediaImageRulesPayloadActionType>) => {
      const { key, rule } = action.payload
      state.mediaRules.images[key] = rule
    },
    setMediaFileRule: (state, action: PayloadAction<SetMediaFileRulesPayloadActionType>) => {
      const { key, rule } = action.payload
      state.mediaRules.files[key] = rule
    },
    setBackgroundImages: (state, action: PayloadAction<SetBackgroundImagesPayloadType>) => {
      state.backgroundImages = action.payload
    },
    setBackgroundImagesV2: (state, action: PayloadAction<SetBackgroundImagesPayloadType>) => {
      state.backgroundImagesV2 = action.payload
    },
    setLoginStory: (state, action: PayloadAction<SetLoginStoryPayloadType>) => {
      const { uniqueID, value } = action.payload

      state.loginStories.some((el, i) => {
        if (el.uniqueID === uniqueID) {
          state.loginStories[i] = {
            ...state.loginStories[i],
            ...value,
          }
        }
        return el.uniqueID === uniqueID
      })
    },
    setBackgroundImage: (state, action: PayloadAction<SetBackgroundImagePayloadActionType>) => {
      const { uniqueID, value } = action.payload

      state.backgroundImages.some((el, i) => {
        if (el.uniqueID === uniqueID) {
          state.backgroundImages[i] = {
            ...state.backgroundImages[i],
            ...value,
          }
        }
        return el.uniqueID === uniqueID
      })
    },
    setBackgroundImageV2: (state, action: PayloadAction<SetBackgroundImagePayloadActionType>) => {
      const { uniqueID, value } = action.payload

      state.backgroundImagesV2.some((el, i) => {
        if (el.uniqueID === uniqueID) {
          state.backgroundImagesV2[i] = {
            ...state.backgroundImagesV2[i],
            ...value,
          }
        }
        return el.uniqueID === uniqueID
      })
    },
  },
})

export const {
  reset,
  setQuery,
  setIsloading,
  setLoginStories,
  setLoginStory,
  setBackgroundImages,
  setBackgroundImagesV2,

  setMediaFileRule,
  setMediaImageRule,
  setBackgroundImage,
  setBackgroundImageV2,
} = onboardingMedia.actions
export default onboardingMedia.reducer
